// src/components/admin/AdminLayout.jsx
import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

// Pages
import Dashboard from "../../pages/Dashboard";
import Marketing from "../../pages/Marketing";
import WebsiteProjects from "../../pages/WebsiteProjects";
import HR from "../../pages/HR";
import AnalyticsAndReports from "../../pages/AnalyticsAndReports";
import Finance from "../../pages/Finance";
import Operations from "../../pages/Operations";
import Documents from "../../pages/Documents";
import Settings from "../../pages/Settings";
import Message from "../../pages/Message";

/* 🔥 FINANCE PAGES */
import Budgeting from "../../pages/Budgeting";
import Invoices from "../../pages/Invoices"; // ✅ ADDED
// optional:
// import FinanceReports from "../../pages/FinanceReports";

export default function AdminLayout() {

  /* ===============================
     LOAD SAVED PAGE
  =============================== */
  const [activePage, setActivePage] = useState(
    localStorage.getItem("adminPage") || "Dashboard"
  );

  /* ===============================
     SAVE PAGE
  =============================== */
  useEffect(() => {
    localStorage.setItem("adminPage", activePage);
  }, [activePage]);

  /* ===============================
     PAGE RENDERER (UPDATED 🔥)
  =============================== */
  const renderPage = () => {

    switch (activePage) {

      case "Dashboard":
        return <Dashboard />;

      case "Marketing":
        return <Marketing />;

      case "Website Projects":
        return <WebsiteProjects />;

      case "HR":
        return <HR />;

      case "Analytics Reports":
        return <AnalyticsAndReports />;

      /* ===============================
         FINANCE MODULE
      =============================== */
      case "Finance":
        return <Finance />;

      case "Budgeting":
        return <Budgeting />;

      case "Invoices": // ✅ FIXED (REAL PAGE NOW)
        return <Invoices />;

      case "Finance Reports":
        return <AnalyticsAndReports />; // (or replace later)

      /* ===============================
         OPERATIONS MODULE
      =============================== */
      case "Operations":
        return <Operations />;

      case "Logistics":
        return <Operations />;

      case "Processes":
        return <Operations />;

      /* =============================== */
      case "Documents":
        return <Documents />;

      case "Message":
        return <Message />;

      case "Settings":
        return <Settings />;

      default:
        return <Dashboard />;
    }
  };

  return (
    <div className="flex h-screen overflow-hidden">

      {/* Sidebar */}
      <Sidebar activePage={activePage} setActivePage={setActivePage} />

      {/* Main Content */}
      <div className="flex-1 flex flex-col md:ml-64">

        {/* Topbar */}
        <Topbar />

        {/* Page Content */}
        <main className="flex-1 mt-16 overflow-y-auto p-6 bg-gray-50">
          <div className="max-w-7xl mx-auto w-full">
            {renderPage()}
          </div>
        </main>

      </div>
    </div>
  );
}